// phoneFormatter.js
import { AsYouType,parsePhoneNumberFromString } from "libphonenumber-js";

export default function initPhoneFormatter(phoneSelectors, countrySelector) {
    const $phoneInputs = $(phoneSelectors);
    const $countryInput = $(countrySelector);

    function formatInput(e) {
        const $input = $(e.target); 

        const country = $countryInput.val().toUpperCase(); // "GN", "FR", ...
        const inputVal = $input.val().replace(/\D/g, ""); 

        if (!country || !inputVal) return;

        const phoneNumber = parsePhoneNumberFromString(inputVal, country);

        if (!phoneNumber || !phoneNumber.isValid()) {
            $input.addClass("is-invalid");
        } else {
            $input.removeClass("is-invalid");
            $input.addClass("is-valid");
        }
        
        $input.val(inputVal);

        const formatter = new AsYouType(country);
        const formatted = formatter.input(inputVal);

        $input.val(formatted);
    }

    // Brancher les événements
    $phoneInputs.on("input", formatInput);
    $countryInput.on("change input", () =>
        $phoneInputs.each((_, el) => formatInput({ target: el }))
    );

    // 🔥 Appliquer dès le chargement de la page
    $(document).ready(() => {
        $phoneInputs.each((_, el) => formatInput({ target: el }));
    });
}

